<template>
  <nx-editor v-if="!loading">
    <template v-slot:title>

      <v-btn icon flat :href="board.publicUrl" v-if="board.published" target="_blank">
        <v-icon>link</v-icon>
      </v-btn>

      <span class="nx-title">{{ board.title | capitalize }}</span>
    </template>

    <template v-slot:metadata>
      <nx-chip
        class="hidden-sm-and-down" dark info>
        ID: {{ board.id }}
      </nx-chip>

      <v-tooltip v-if="board.creationDate" bottom class="hidden-sm-and-down">
        <nx-chip slot="activator" class="hidden-sm-and-down" dark default>
          {{ board.creationDate | formatDate }}
        </nx-chip>
        {{ $t('message.metadata.creationDate') }}
      </v-tooltip>

      <v-tooltip v-if="board.modificationDate" bottom class="hidden-sm-and-down">
        <nx-chip slot="activator" class="hidden-sm-and-down" dark default>
          {{ board.modificationDate | formatDate }}
        </nx-chip>
        {{ $t('message.metadata.modificationDate') }}
      </v-tooltip>

      <nx-chip v-if="board.published" dark success>
        {{ $t('message.metadata.published') }}
      </nx-chip>

      <nx-chip v-if="board.isDraft" class="hidden-sm-and-down" dark alert>
        {{ $t('message.metadata.draft') }}
      </nx-chip>

      <v-tooltip v-if="board.publishedDate" bottom class="hidden-sm-and-down">
        <nx-chip slot="activator" class="hidden-sm-and-down" dark default>
          {{ board.publishedDate | formatDate }}
        </nx-chip>
        {{ $t('message.metadata.publishedDate') }}
      </v-tooltip>
    </template>

    <template #extension>
      <nx-editor-breadcrumbs
        type="board"
        :id="boardId"
      ></nx-editor-breadcrumbs>
    </template>

    <template v-slot:body>
      <v-container class="nx-container white" fluid>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-list two-line v-if="blocks.length > 0">
              <template v-for="(dayparting, index) in blocks">
                <v-list-tile
                  avatar
                  :key="dayparting.id"
                  :to="{ name: 'dayparting.editor', params: { id: dayparting.id }, query: { refBoard: boardId } }"
                >
                  <v-list-tile-avatar>
                    <v-icon>today</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title class="nx-heading--level-2">
                      {{ dayparting.alias }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <div class="badges">
                        <nx-badge v-if="dayparting.published" color="nx-primary--lighten-4 nx-text--level-1">
                          {{ dayparting.publishedDate | formatDate }}
                        </nx-badge>
                        <nx-badge v-else color="nx-primary--lighten-4 nx-text--level-1">
                          {{ dayparting.modificationDate | formatDate }}
                        </nx-badge>
                        <nx-badge v-if="dayparting.published">
                          {{ $t('message.content.status.published') }}
                        </nx-badge>
                        <nx-badge v-else>
                          {{ $t('message.content.status.draft') }}
                        </nx-badge>
                      </div>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon ripple>
                      <v-icon
                        color="secondary"
                        :to="{ name: 'dayparting.editor', params: { id: dayparting.id } }"
                      >
                        edit
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>

                </v-list-tile>
                <v-divider v-if="index + 1 < blocks.length" :key="`divider-${index}`"></v-divider>
              </template>
            </v-list>
            <v-layout v-else justify-center align-contents-center fill-height>
              <v-flex xs12 class="text-xs-center">
                <v-icon size="70" class="mb-1">today</v-icon>
                <p class="subheading">No hay dayparting configurado para esta portada</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </nx-editor>
</template>

<script>
import NxEditor from '@/components/editor/Editor';
import NxBadge from '@/components/Badge';
import NxEditorBreadcrumbs from '@/components/editor/EditorBreadcrumbs';
import toast from '@/modules/toast/services';
import api from '../api';
import NxChip from '@/components/chips/Chip';

export default {
  name: 'nx-board-dayparting-list',
  components: {
    NxChip,
    NxEditorBreadcrumbs,
    NxBadge,
    NxEditor,
  },
  metaInfo() {
    return {
      title: this.board ? this.board.title : null,
      // all titles will be injected into this template
      titleTemplate: this.board ? '%s | BCube CMS' : 'BCube CMS',
    };
  },
  props: {
    boardId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      board: {},
      dayparting: {},
    };
  },
  computed: {
    blocks() {
      return this.dayparting.blocks || [];
    },
  },
  async mounted() {
    try {
      this.loading = true;
      [this.dayparting, this.board] = await Promise.all([
        api.getBoardDayparting(this.boardId),
        api.getBoardMetadata(this.boardId),
      ]);
    } catch (error) {
      console.error(error);
      toast.notify('message.error.serverError');
    } finally {
      this.loading = false;
      this.$emit('loaded');
    }
  },
};
</script>
<style lang="stylus" scoped>
.nx-container {
  margin-top: 118px;
}
</style>
